import { Payments_Get } from "data/endpoints";
import React from "react";
import PaymentDTO from "../dtos/PaymentDTO";
import PaymentInfoCard from "../components/PaymentInfoCard";
import PaymentUsageDetail from "../components/PaymentUsageDetail";
import Card from "features/shared/components/card/Card";
import PaymentUsageDetailHeader from "../components/PaymentUsageDetailHeader";
import { getRouteParams } from "features/shared/helpers/routeParams";
import { useQuery } from "data/hooks/useQuery";
import { getQueryParams } from "features/shared/helpers/queryParams";
import { useSelector } from "react-redux";
import IAppState from "infrastructure/store/IAppState";
import CustomerState from "infrastructure/store/customer/CustomerState";
import NoContentWrapper from "features/shared/components/noContentWrapper/NoContentWrapper";
import { useTranslation } from "react-i18next";

interface Props {
  paymentId: string;
}

const PaymentDetailSection = ({ paymentId }: Props) => {
  // translations
  const tLabels = useTranslation("payments\\payments").t;

  // store
  const customer = useSelector<IAppState, CustomerState>((store) => store.customer).customer;

  // side-effects
  // fetch data
  const { data: payment, loadStatus } = useQuery<PaymentDTO>(
    {
      url: Payments_Get,
      routeParams: getRouteParams("paymentId", paymentId),
      params: getQueryParams("CustomerId", customer.customerId!),
    },
    {},
    [paymentId]
  );

  // render
  return (
    <NoContentWrapper
      data={payment}
      loadStatus={loadStatus}
      noContentAsAlert
    >
      <PaymentInfoCard payment={payment} />
      <div className="mt-sm-4">
        <h5 className="d-sm-none text-muted">{tLabels("paymentDetailSection.usedForPayment")}</h5>
        <PaymentUsageDetailHeader />
        {payment.paymentUsage?.map((item, index) => (
          <Card className="py-2 px-2 px-sm-3 mb-2" key={index}>
            <PaymentUsageDetail paymentUsage={item} />
          </Card>
        ))}
      </div>
    </NoContentWrapper>
  );
};

export default PaymentDetailSection;
